export default "__VITE_ASSET__BmYQ2HHM__"